"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { useEffect, useState } from "react";
export function CookieConsent(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const [cookieConsent, setCookieConsent] = useState(null);
  const [show, setShow] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const stored = localStorage.getItem("cookieConsent");
      setTimeout(() => {
        setCookieConsent(stored);
        setShow(true);
      }, 0);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => {
      setCookieConsent(value);
      localStorage.setItem("cookieConsent", value);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleSetConsent = t3;
  if (cookieConsent === "accepted" && children) {
    let t4;
    if ($[3] !== children) {
      t4 = <>{children}</>;
      $[3] = children;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (cookieConsent !== null) {
    return null;
  }
  const t4 = `pointer-events-auto fixed right-0 bottom-0 left-0 z-9999 w-full transition-all duration-200 ease-in-out sm:bottom-4 sm:left-4 sm:max-w-md ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-8 opacity-0"}`;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center justify-between p-3"><h1 className="text-lg font-semibold">Cookies</h1><Cookie className="h-[1.2rem] w-[1.2rem]" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="-mt-2 p-3"><p className="text-muted-foreground text-left text-sm">Utilizamos cookies para mejorar la experiencia en nuestra página.</p></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button onClick={() => {
      handleSetConsent("accepted");
    }}>Aceptar</Button>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="dark:bg-card bg-background border-border m-3 rounded-lg border">{t5}{t6}<div className="mt-2 flex items-center gap-2 border-t p-3">{t7}<Button onClick={() => {
          handleSetConsent("declined");
        }} variant="outline">Rechazar</Button></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4) {
    t9 = <div className={t4}>{t8}</div>;
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}